import { render } from "./Modal.vue?vue&type=template&id=e6f31ff0"
import script from "./Modal.vue?vue&type=script&lang=js"
export * from "./Modal.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "e6f31ff0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e6f31ff0', script)) {
    api.reload('e6f31ff0', script)
  }
  
  module.hot.accept("./Modal.vue?vue&type=template&id=e6f31ff0", () => {
    api.rerender('e6f31ff0', render)
  })

}

script.__file = "resources/js/RooomGuide/Modal.vue"

export default script